import { ThemeType } from '@app/interfaces/interfaces';
import { createSlice, createAction, PrepareAction } from '@reduxjs/toolkit';

interface ThemeState {
  theme: ThemeType;
  // Màu chủ đạo tuỳ chỉnh của user (hex). '' = dùng mặc định theo theme.
  customPrimary: string;
}

const preferredTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

export const defaultTheme = (localStorage.getItem('theme') as ThemeType) || preferredTheme;

localStorage.setItem('theme', defaultTheme);

export const defaultCustomPrimary = localStorage.getItem('customPrimaryColor') || '';

const initialState: ThemeState = {
  theme: defaultTheme,
  customPrimary: defaultCustomPrimary,
};

export const setTheme = createAction<PrepareAction<ThemeType>>('theme/setTheme', (theme: ThemeType) => {
  localStorage.setItem('theme', theme);
  return {
    payload: theme,
  };
});

// Đặt/xoá màu chủ đạo tuỳ chỉnh (persist localStorage). Truyền '' để khôi phục mặc định.
export const setCustomPrimary = createAction<PrepareAction<string>>('theme/setCustomPrimary', (color: string) => {
  if (color) {
    localStorage.setItem('customPrimaryColor', color);
  } else {
    localStorage.removeItem('customPrimaryColor');
  }
  return {
    payload: color,
  };
});

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setTheme, (state, action) => {
      state.theme = action.payload;
    });
    builder.addCase(setCustomPrimary, (state, action) => {
      state.customPrimary = action.payload;
    });
  },
});

export default themeSlice.reducer;
